import { AnyAction, createSlice } from '@reduxjs/toolkit';
import { buyNowCart } from '../../data-access/apis/modals/buyNow';
import { ResponseType } from '../../interfaces/response';

const buyNowModalSlice = createSlice({
  name: 'buyNowModal',
  initialState: {
    status: ResponseType.Pending,
    statusCode: null,
    loading: false,
    message: null,
    errors: null,
  },
  reducers: {
    resetBuyNowModal: (state) => {
      state.status = ResponseType.Pending;
      state.statusCode = null;
      state.loading = false;
      state.message = null;
      state.errors = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(buyNowCart.pending, (state) => {
        state.loading = true;
        state.status = ResponseType.Pending;
      })
      .addCase(buyNowCart.fulfilled, (state, action: AnyAction) => {
        state.loading = false;
        state.status = ResponseType.Success;
        state.message = action.payload.message;
        state.statusCode = action.payload.status;
      })
      .addCase(buyNowCart.rejected, (state, action: AnyAction) => {
        state.loading = false;
        state.status = ResponseType.Failed;
        state.statusCode = action.payload?.status || 500;
        state.message = action.payload?.message || 'Something went wrong';
        state.errors = action.error?.message || null;
      });
  },
});

export const { resetBuyNowModal } = buyNowModalSlice.actions;
export default buyNowModalSlice.reducer;
